import { h, render } from 'preact'
import TUIPaymentsComponent from './mainComponent'
import { DataDog } from '../app/datadog'

export default class TUIPayments extends HTMLElement {
  static get observedAttributes() {
    return [
      'components',
      'token',
      'lang',
      'theme',
      'amount',
      'is-payment-blocked',
      'available-payment-methods',
      'selected-payment-method',
      'styles-href',
      'paypal-button-style',
      'paypalcredit-button-style',
      'show-hours-in-timer',
      'show-payment-confirmation',
      'metadata',
      'loader-image',
    ]
  }

  constructor() {
    super()

    this.attr = {}
    this.initialiseData = {}

    this.shadow = this.attachShadow({ mode: 'open' })
  }

  connectedCallback() {
    const theme = this.attr?.theme || 'tui'
    this.mountPoint = document.createElement('div')
    this.mountPoint.setAttribute('theme', theme)
    this.mountPoint.setAttribute('class', 'opp-theme-override payment-opp-root')
    this.shadow.appendChild(this.mountPoint)
    this.#render()
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      DataDog.info('MFE attribute has changed', {
        name,
        oldValue,
        newValue,
      })
      this.attr[name] = newValue
      this.#render()
    }
  }

  #createApp(Component, props) {
    return h(Component, props, h('slot'))
  }

  #renderApp(Component, props) {
    if (this.mountPoint) {
      render(this.#createApp(Component, props), this.mountPoint)
    }
  }

  getInitialiseData() {
    return this.initialiseData
  }

  #render() {
    const token = this.attr?.token
    const lang = this.attr?.lang
    const components = this.attr?.components
    const amount = this.attr?.amount
    const theme = this.attr?.theme
    const isPaymentBlocked = this.attr['is-payment-blocked']
    const availablePaymentMethods = this.attr['available-payment-methods']
    const selectedPaymentMethod = this.attr['selected-payment-method']
    const stylesHref = this.attr['styles-href']
    const paypalButtonStyle = this.attr['paypal-button-style']
    const paypalcreditButtonStyle = this.attr['paypalcredit-button-style']
    const showHoursInTimer = this.attr['show-hours-in-timer']
    const showPaymentConfirmation = this.attr['show-payment-confirmation']
    const metadata = this.attr?.metadata
    const loaderImage = this.attr['loader-image']

    window.tuiPaymentsMFEInstance = this

    this.#renderApp(TUIPaymentsComponent, {
      components,
      token,
      lang,
      theme,
      amount,
      isPaymentBlocked,
      availablePaymentMethods,
      selectedPaymentMethod,
      stylesHref,
      paypalButtonStyle,
      paypalcreditButtonStyle,
      showHoursInTimer,
      showPaymentConfirmation,
      metadata,
      loaderImage,
    })
  }
}
